import _ from '@centerhealth/common/lodash';
import { IHeapEvent } from '../interfaces';

export const addDataAttrs = (node: HTMLElement, heapEvent: IHeapEvent): void => {
  // On SSR inital value may be null
  if (!heapEvent) return;

  let str = `${heapEvent.action}-${heapEvent.subAction}`;
  if (!_.isEmpty(heapEvent.sectionName)) str = `${str}-${heapEvent.sectionName}`;
  if (!_.isEmpty(heapEvent.value)) str = `${str}-${heapEvent.value}`;
  node.setAttribute('data-heap', str);
};
